import React from 'react';
import { FaBook, FaUsers, FaChartLine, FaAward, FaRegClock, FaUserGraduate, FaHeart, FaQuoteLeft } from 'react-icons/fa';
import { FiTrendingUp } from 'react-icons/fi';
import DashboardCard from '../pages/home/DashboardCard';
import ShayariOfTheDay from '../pages/home/ShayariOfTheDay';

const Home = () => {
   



    return (
        <div className="space-y-6 p-1 md:p-2">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl md:text-3xl font-bold text-[--text-color]">Dashboard Overview</h1>
            </div>

            {/* Dashboard Cards Grid */}
            <div>
                <DashboardCard />
            </div>

            {/* Shayari of the Day */}
            <div>
                <ShayariOfTheDay />
            </div>


            {/* Recent Activities and Top Students */}
          
        </div>
    );
};

export default Home;